import { level } from '../api/entities';

export const actions = {
  listLevel: 'LIST_LEVEL',
};

export function getLevels() {
  return level.list(actions.listLevel, null, null, true);
}

const INITIAL_STATE = {
  levels: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listLevel:
      return {
        ...state,
        levels: action.body ? action.body._items : state.levels,
      };
    default:
      return {
        ...state,
      };
  }
}
